export default from './bordered-tooltip';



// WEBPACK FOOTER //
// ./app/components/bordered-tooltip/index.js